__turbopack_context__.v({
  "zerocase": "sections-module-scss-module__mkoT4a__zerocase",
});
